import { ProductType } from '@shared/enums/product-type';
import { VariantType } from '@shared/enums/variant-type';

export enum ActivityStatus {
  New = 'New',
  Saved = 'Saved',
  InReview = 'InReview',
  NeedsWork = 'NeedsWork',
  Complete = 'Complete'
}

/**
 * Used by {@link ActivityService} to consolidate multiple endpoints into one set of logic.
 */
export enum ActivityKind {
  Video = 'video',
  SuperSmart = 'super-smart',
  Resource = 'resource',
}

export interface ActivityQuery {
  topicKey: string,
  productType: ProductType,
  activityKey: string,
}

export interface ActivityUpdate {
  activityId: string | null,
  classroomId: string,
  topicKey: string,
  activityKey: string | null,
  sectionKey: string | null,
  productType: ProductType,
  grade: VariantType,
  status: ActivityStatus,
}

export interface ActivityResponse {
  activityId: string,
  classroomId: string,
  topicKey: string,
  activityKey: string,
  sectionKey: string,
  productType: ProductType,
  grade: VariantType,
  status: ActivityStatus,
}
